<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Contribution
      <employee-profile-payroll-payroll-company-contribution-dialog-create
        v-if="$hasPermissionTo(['update employee payroll']) && !companyEmployee.end_date"
        :company-employee-uid="companyEmployee.company_employee_uid"
        @created="$emit('load')"
      />
    </h4>

    <v-row
      v-if="isNoContributions"
      class="mx-0"
    >
      <v-col
        cols="2"
        class="py-0"
      />
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-left">
          Employee
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-left">
          Employer
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-left">
          Start Date
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      >
        <div class="font-weight-medium text-left">
          End Date
        </div>
      </v-col>
      <v-col
        cols="2"
        class="py-0"
      />
    </v-row>

    <v-row
      v-else
      class="mx-0"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        No Data Available
      </v-col>
    </v-row>

    <v-row
      v-for="(epfContribution,index) in companyEmployee.company_employee_epf_contributions"
      :key="`epf-${index}`"
      class="mx-0"
    >
      <v-col class="pa-0">
        <v-row
          class="mx-0"
        >
          <v-col class="pa-0">
            <v-row
              class="mx-0"
            >
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="font-weight-medium text-left">
                  <v-tooltip
                    bottom
                    min-width="250"
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon
                        small
                        color="info"
                        v-on="{ ...tooltip }"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div>Created by: <b>{{ epfContribution.created_by }}</b> on <b>{{ $moment(epfContribution.created_at).format('DD-MM-YYYY') }}</b></div>
                    <div>Updated by: <b>{{ epfContribution.updated_by }}</b> on <b>{{ $moment(epfContribution.updated_at).format('DD-MM-YYYY') }}</b></div>
                  </v-tooltip>

                  EPF
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1 text-left"
              >
                <v-icon medium>
                  {{ epfContribution.is_employee_contributed ? 'mdi mdi-check text-success' : 'mdi mdi-close text-danger' }}
                </v-icon>
                <span v-if="epfContribution.is_employee_contributed">
                  {{ epfContribution.employee_contribution_deduction_id ? 'Follow Gov. Rate' : epfContribution.employee_customized_rate ? epfContribution.employee_customized_rate/100 + '%' : 'RM' + epfContribution.employee_customized_amount/100 }}
                </span>
              </v-col>
              <v-col
                cols="2"
                class="py-1 text-left"
              >
                <v-icon medium>
                  {{ epfContribution.is_employer_contributed ? 'mdi mdi-check text-success' : 'mdi mdi-close text-danger' }}
                </v-icon>
                <span v-if="epfContribution.is_employee_contributed">
                  {{ epfContribution.employer_contribution_deduction_id? 'Follow Gov. Rate' : epfContribution.employer_customized_rate ? epfContribution.employer_customized_rate/100 + '%' : 'RM' + epfContribution.employer_customized_amount/100 }}
                </span>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  {{ epfContribution.start_date ? $moment(epfContribution.start_date).format('MMM YYYY'):'N/A' }}
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  {{ epfContribution.end_date? $moment(epfContribution.end_date ).format('MMM YYYY') :'N/A' }}
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <employee-profile-payroll-payroll-company-contribution-epf-dialog-edit
                  v-if="!companyEmployee.end_date && !epfContribution.end_date && $hasPermissionTo(['update employee payroll'])"
                  :epf-contribution="epfContribution"
                  :company-employee-start-date="companyEmployee.start_date"
                  @updated="$emit('load')"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-for="(socsoContribution,index) in companyEmployee.company_employee_socso_contributions"
      :key="`socso-${index}`"
      class="mx-0"
    >
      <v-col class="pa-0">
        <v-row
          class="mx-0"
        >
          <v-col class="pa-0">
            <v-row
              class="mx-0"
            >
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="font-weight-medium text-left">
                  <v-tooltip
                    bottom
                    min-width="250"
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon
                        small
                        color="info"
                        v-on="{ ...tooltip }"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div>Created by: <b>{{ socsoContribution.created_by }}</b> on <b>{{ $moment(socsoContribution.created_at).format('DD-MM-YYYY') }}</b></div>
                    <div>Updated by: <b>{{ socsoContribution.updated_by }}</b> on <b>{{ $moment(socsoContribution.updated_at).format('DD-MM-YYYY') }}</b></div>
                  </v-tooltip>

                  SOCSO
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1 text-left"
              >
                <div>
                  <v-icon medium>
                    {{ socsoContribution.is_employee_contributed ? 'mdi mdi-check text-success' : 'mdi mdi-close text-danger' }}
                  </v-icon>

                  <v-tooltip
                    v-if="socsoContribution.is_employee_skbbk_contributed"
                    bottom
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon
                        color="blue"
                        v-on="{ ...tooltip }"
                      >
                        mdi-shield-check
                      </v-icon>
                    </template>
                    Contribute to SKBBK
                  </v-tooltip>
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  <v-icon medium>
                    {{ socsoContribution.is_employer_contributed ? 'mdi mdi-check text-success' : 'mdi mdi-close text-danger' }}
                  </v-icon>
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  {{ socsoContribution.start_date? $moment(socsoContribution.start_date).format('MMM YYYY') :'N/A' }}
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  {{ socsoContribution.end_date? $moment(socsoContribution.end_date ).format('MMM YYYY') :'N/A' }}
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <employee-profile-payroll-payroll-company-contribution-socso-dialog-edit
                  v-if="!companyEmployee.end_date && !socsoContribution.end_date && $hasPermissionTo(['update employee payroll'])"
                  :socso-contribution="socsoContribution"
                  :company-employee-start-date="companyEmployee.start_date"
                  @updated="$emit('load')"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>  

    <v-row
      v-for="(eisContribution,index) in companyEmployee.company_employee_eis_contributions"
      :key="`eis-${index}`"
      class="mx-0"
    >
      <v-col class="pa-0">
        <v-row
          class="mx-0"
        >
          <v-col class="pa-0">
            <v-row
              class="mx-0"
            >
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="font-weight-medium text-left">
                  <v-tooltip
                    bottom
                    min-width="250"
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <v-icon
                        small
                        color="info"
                        v-on="{ ...tooltip }"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <div>Created by: <b>{{ eisContribution.created_by }}</b> on <b>{{ $moment(eisContribution.created_at).format('DD-MM-YYYY') }}</b></div>
                    <div>Updated by: <b>{{ eisContribution.updated_by }}</b> on <b>{{ $moment(eisContribution.updated_at).format('DD-MM-YYYY') }}</b></div>
                  </v-tooltip>

                  EIS
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  <v-icon medium>
                    {{ eisContribution.is_employee_contributed ? 'mdi mdi-check text-success' : 'mdi mdi-close text-danger' }}
                  </v-icon>
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  <v-icon medium>
                    {{ eisContribution.is_employer_contributed ? 'mdi mdi-check text-success' : 'mdi mdi-close text-danger' }}
                  </v-icon>
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  {{ eisContribution.start_date ? $moment(eisContribution.start_date).format('MMM YYYY') :'N/A' }}
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <div class="text-left">
                  {{ eisContribution.end_date ? $moment(eisContribution.end_date ).format('MMM YYYY') : 'N/A' }}
                </div>
              </v-col>
              <v-col
                cols="2"
                class="py-1"
              >
                <employee-profile-payroll-payroll-company-contribution-eis-dialog-edit
                  v-if="!companyEmployee.end_date && !eisContribution.end_date && $hasPermissionTo(['update employee payroll'])"
                  :eis-contribution="eisContribution"
                  :company-employee-start-date="companyEmployee.start_date"
                  @updated="$emit('load')"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyContributionDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyContributionEpfDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/epf/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyContributionSocsoDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/socso/DialogEdit'),
      EmployeeProfilePayrollPayrollCompanyContributionEisDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/contribution/eis/DialogEdit'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    computed: {
      isNoContributions () {
        return this.companyEmployee.company_employee_epf_contributions.length > 0 && 
          this.companyEmployee.company_employee_socso_contributions.length > 0 &&
          this.companyEmployee.company_employee_eis_contributions.length > 0 
      },
    },
  }
</script>
